import { Injectable, inject } from '@angular/core';
import { Meta } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class MetaService {
  private readonly meta = inject(Meta);

  addMetaToPage(description: string) {
    const metaDescription = this.meta.getTag('name=description');

    if (metaDescription) {
      this.meta.updateTag({
        name: 'description',
        content: description,
      });
    } else {
      this.meta.addTag({
        name: 'description',
        content: description,
      });
    }
  }
}
